import { render, staticRenderFns } from "./VideoView.vue?vue&type=template&id=2b64edc9&scoped=true"
import script from "./VideoView.vue?vue&type=script&lang=ts"
export * from "./VideoView.vue?vue&type=script&lang=ts"
import style0 from "./VideoView.vue?vue&type=style&index=0&id=2b64edc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b64edc9",
  null
  
)

export default component.exports